import { LoginCredentialsForm } from "@/features/auth/components/LoginCredentialsForm";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { getQueryFromURL } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Navigate } from "react-router-dom";

type TQuery = {
  externalId?: string;
  redirectUrl?: string;
};

type TLoginCredentialsPageProps = {};

export const LoginCredentialsPage: FC<TLoginCredentialsPageProps> = () => {
  const query = getQueryFromURL<TQuery>();
  const externalId = query?.externalId?.trim();

  if (!externalId) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <LoginCredentialsForm externalId={externalId} />
    </Stack>
  );
};
